import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  draftOrderListParams,
  draftOrderListQueryOptions,
  draftOrderListSearchSchema,
  DraftOrdersPage,
} from '@/features/draft-orders';

export const Route = createFileRoute('/_authed/_active/s/$storeId/draft-orders/')({
  staticData: { tours: ['draft-orders.list'] },
  validateSearch: draftOrderListSearchSchema,
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'orders.read');
  },
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...draftOrderListQueryOptions(params.storeId, draftOrderListParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    // A filter, sort or page change on the list itself must not wait for the fetch: the URL
    // would lag behind, and a second click in the picker would build on the stale filters.
    if (cause !== 'stay') await prefetch;
  },
  component: DraftOrdersPage,
});
